import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import "../styles/BackofficeLayout.css";
export default function BackofficeLayout() {
    const [mobileOpen, setMobileOpen] = useState(false);
    return (
        <div className="backoffice-layout">
            <Sidebar mobileOpen={mobileOpen} setMobileOpen={setMobileOpen} />
            <div className="backoffice-main">
                <Header setMobileOpen={setMobileOpen} />
                <main className="backoffice-content"><Outlet /></main>
            </div>
        </div>
    );
}